module.exports = __webpack_public_path__ + "assets/images/project/south-africa.jpg?v=97b03a5e";